import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import { first, finalize } from 'rxjs/operators';
import { retry, timeout, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

import { of } from 'rxjs';
import { switchMap, concatMap, tap } from 'rxjs/operators';

import { NgxSpinnerService } from 'ngx-spinner';
import { CreateDossierParticulier } from 'src/app/particulier/core/model/particulier/create-dossier-particulier';
import { BpParticulierService } from 'src/app/parametrage/core/service/bp-particulier.service';
import { BpEngagementService } from 'src/app/parametrage/core/service/bp-engagement.service';
import { BpParticulier } from 'src/app/parametrage/core/model/bp-particulier';
import { BpEngagement } from 'src/app/parametrage/core/model/bp-engagement';
import { EmployeurService } from 'src/app/parametrage/core/service/employeur.service';
import { Employeur } from 'src/app/parametrage/core/model/employeur';
import { TypeCredit } from 'src/app/parametrage/core/model/type-credit';
import { TypeCreditService } from 'src/app/parametrage/core/service/type-credit.service';
import { ProduitService } from 'src/app/parametrage/core/service/produit.service';
import { Produit } from 'src/app/parametrage/core/model/produit';
import { Assurance } from 'src/app/parametrage/core/model/assurance';
import { AssuranceService } from 'src/app/parametrage/core/service/assurance.service';
import { TauxFraisInput } from 'src/app/particulier/core/model/rule/taux-frais-input';
import { TauxFraisOutput } from 'src/app/particulier/core/model/rule/taux-frais-output';
import { AnalyseParticulierInput } from 'src/app/particulier/core/model/rule/analyse-particulier-input';
import { AnalyseParticulierOutput } from 'src/app/particulier/core/model/rule/analyse-particulier-output';
import { RuleParticulierService } from 'src/app/particulier/core/service/rule-particulier.service';
import { ParticulierFaciliteItem } from 'src/app/particulier/core/model/particulier/particulier-facilite-item';
import { ParticulierService } from 'src/app/particulier/core/service/particulier.service';
import {
  NgbActiveModal,
  NgbDateAdapter,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap";
import {
  CustomAdapter,
  CustomDateParserFormatter,
} from "src/app/shared/adapters/datepicker-adapter";
import { IndividualService } from 'src/app/parametrage/core/service/individual.service';
import { Individual } from 'src/app/parametrage/core/model/individual/individual';
import { RetailItemService } from 'src/app/particulier/core/service/retail-item.service';
import { RetailItem } from 'src/app/particulier/core/model/retail-item';
import { Request } from 'src/app/parametrage/core/model/request';
import { RequestService } from 'src/app/parametrage/core/service/request.service';

@Component({
  selector: 'app-create-dossier-credit',
  templateUrl: './create-dossier-credit.component.html',
  styleUrls: ['./create-dossier-credit.component.scss'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class CreateDossierCreditComponent implements OnInit {

  workflowCode : String;

  requestIdParent : String;
  selectedTypeCredit: TypeCredit;
  selectedProduit: Produit;
  dossier: Request;

  errorMessage: string;
  pressButton:Boolean = false;

  form: FormGroup;

  dossierCredit: CreateDossierParticulier = new CreateDossierParticulier();

  bpParticulier:BpParticulier;
  bpEngagement:BpEngagement;

  dateControl:FormControl;
  dateControlExpPiece:FormControl;
  dateControlNaissance:FormControl;
  
  employeurs: Employeur[];

  allTypeCredits: TypeCredit[] = [];
  typeCredits: TypeCredit[];
  produits:Produit[];
  assurances:Assurance[];
  
  tauxFraisInput : TauxFraisInput = new TauxFraisInput();
  tauxFraisOutput : TauxFraisOutput;

  analyseParticulierInput : AnalyseParticulierInput = new AnalyseParticulierInput();
  analyseParticulierOutput : AnalyseParticulierOutput;

  totalRevenuMensuel:number=0;
  totalEngagementMensuel:number=0;
  disponibleMensuel:number=0;
  quotite:number=0;
  quotiteNormale:number=0;
  avisAnalyseRisque:Boolean=false;
  avisSurDemande:Boolean=false;

  decouvertMaximum:number = 0;
  decouvertDepassement:number = 0;
  totalEgagementClient:number = 0;
  quotiteApresEngagement:number = 0;

  isCalculated:Boolean=false;

  individual: Individual;
  facilites: RetailItem[];

  constructor(private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private _bpEngagementService: BpEngagementService,
    private _bpParticulierService: BpParticulierService,
    private _employeurService : EmployeurService,
    private _typeCreditService : TypeCreditService,
    private _produitService:ProduitService,
    private _assuranceService : AssuranceService,
    private _ruleParticulierService : RuleParticulierService,
    private _particulierService : ParticulierService,
    private _individualService: IndividualService,
    private _retailItemService: RetailItemService,
    private _requestService: RequestService,
    private fb: FormBuilder) 
    {
      this.createForm();
    }


    createForm() 
    {
        this.form = this.fb.group({

          //info client
          categorie: ['AUTRE', Validators.compose([Validators.required])],
          customerCode: [
            null, 
            Validators.compose([Validators.required])
          ],
          dateReceptionDossier:['', 
            [
              Validators.compose([Validators.required])
            ]
          ],
          matricule: [null, Validators.compose([Validators.required])],
          firstname: [null, Validators.compose([Validators.required])],
          lastname: [null, Validators.compose([Validators.required])],
          fonction: [null, Validators.compose([Validators.nullValidator])],
          email: [null, Validators.compose([Validators.nullValidator])],
          situationMatrimoniale: [null, Validators.compose([Validators.nullValidator])],
          adressePostale: [null, Validators.compose([Validators.nullValidator])],
          adresseGeographique: [null, Validators.compose([Validators.required])],
          homePhone: [null, Validators.compose([Validators.nullValidator])],
          mobilePhone: [null, Validators.compose([Validators.required])],
          workPhone: ['', Validators.compose([Validators.nullValidator])],
          employeurName: [null, Validators.compose([Validators.nullValidator])],
          employeur: [null, Validators.compose([Validators.required])],
          employeurAdresse: [null, Validators.compose([Validators.nullValidator])],

          dateEmbauche: ['', Validators.compose([Validators.nullValidator])],

          ancienneteEmploi:['', 
            [
              Validators.compose([Validators.nullValidator]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$')
            ]
          ],
          profession: [null, Validators.compose([Validators.required])],
          fonctionDansEntreprise: [null, Validators.compose([Validators.nullValidator])],
          salaireEmprunteur:[0, 
            [
              Validators.compose([Validators.required]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$'),
              Validators.min(0)
            ]
          ],
          salaireConjoint:[0, 
            [
              Validators.compose([Validators.nullValidator]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$'),
              Validators.min(0)
            ]
          ],
          montantLoyer:[0, 
            [
              Validators.compose([Validators.nullValidator]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$'),
              Validators.min(0)
            ]
          ],
          montantAutreRevenu:[0, 
            [
              Validators.compose([Validators.nullValidator]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$'),
              Validators.min(0)
            ]
          ],

          typePiece: ['', Validators.compose([Validators.required])],
          dateExpPiece: ['', Validators.compose([Validators.nullValidator])],
          dateNaissance: ['', Validators.compose([Validators.nullValidator])],
          lieuNaissance: ['', Validators.compose([Validators.required])],

          codeAgenceDomiciliation: [
            '', 
            Validators.compose([Validators.required])
          ],
          libelleAgenceDomiciliation: ['', Validators.compose([Validators.required])],
          rib: ['', Validators.compose([Validators.required])],
          numeroCompte: ['', Validators.compose([Validators.required])],

          totalEngagementActuel:[0, 
            [
              Validators.compose([Validators.required]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$'),
              Validators.min(0)
            ]
          ],
          chargeEmpruntSollicite:[0, 
            [
              Validators.compose([Validators.required]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$'),
              Validators.min(0)
            ]
          ],
          montantBonusDat:[0, 
            [
              Validators.compose([Validators.required]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$'),
              Validators.min(0)
            ]
          ],
          primeTrimestrielle:[0, 
            [
              Validators.compose([Validators.required]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$'),
              Validators.min(0)
            ]
          ],
          domiciliationSalaire: [true, Validators.compose([Validators.required])],
          
          clientEngage: [false, Validators.compose([Validators.required])],
          packageSouscrit: ['AUTRE', Validators.compose([Validators.required])],
          typeCreditSouscrit: [null, Validators.compose([Validators.nullValidator])],
          montantCreditSolicite:[0, 
            [
              Validators.compose([Validators.nullValidator]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$'),
              Validators.min(0)
            ]
          ],
          echeanceMensuelleCreditSolicite:[0, 
            [
              Validators.compose([Validators.nullValidator]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$'),
              Validators.min(0)
            ]
          ],

          //info crédit
          typeCredit: [null, Validators.compose([Validators.required])],
          produit: [null, Validators.compose([Validators.required])],
          assurance: [null, Validators.compose([Validators.nullValidator])],
          montant:[0, 
                [
                  Validators.compose([Validators.required]),
                  Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$'),
                  Validators.min(1)
                ]
          ],
          periodicite: ['MENSUEL', Validators.compose([Validators.required])],
          echeance:[0, 
                [
                  Validators.compose([Validators.required]),
                  Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$'),
                  Validators.min(1)
                ]
          ],
          echeanceMensuelleEnCours:[0, 
            [
              Validators.compose([Validators.nullValidator]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$')
            ]
          ],
          taux:[0, 
            [
              Validators.compose([Validators.nullValidator]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$')
            ]
          ],

          typeMontantVirementPermanent: ['SALAIRE', 
            [
              Validators.compose([Validators.nullValidator]),Validators.maxLength(254)
            ]
          ],
          montantVirementPermanent:[0, 
            [
              Validators.compose([Validators.nullValidator]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$')
            ]
          ],

          montantVirementPonctuel:[0, 
            [
              Validators.compose([Validators.nullValidator]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$')
            ]
          ],

          nombreEcheance:[0, 
            [
              Validators.compose([Validators.nullValidator]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$')
            ]
          ],
          frais:[0, 
            [
              Validators.compose([Validators.nullValidator]),
              Validators.pattern('^-?[0-9]\\d*(\\.\\d*)?$')
            ]
          ],
          objetDemande: ['', 
            [
              Validators.compose([Validators.nullValidator]),
              Validators.maxLength(21843)
            ]
          ],

          //analyse dossier
          avisAnalyseRisque: [null, Validators.compose([Validators.requiredTrue])],
          avisSurDemande: [null, Validators.compose([Validators.requiredTrue])],
    
          garantiesArrayForm: this.fb.array([]),

        });
  }
  
    
  garantiesData = [
    /*{ checked: true, require: true, displayName: 'ravi2', name: 'b', index: 1 },
    { checked: true, require: true, displayName: 'ravi3', name: 'c', index: 2 }*/
  ];
  get garantiesArrayForm(): FormArray {
    return this.form.get("garantiesArrayForm") as FormArray;
  }

  ngOnInit() {
    
    this._activatedRoute.params.subscribe((params: Params) => {
      this.workflowCode = params['workflowCode'];
      this.requestIdParent = params['requestIdParent'];
    });

    this.getAllEmployeur();
    this.getListTypeCredit();
    
    this.mappingDossier();

  }

  mappingDossier()
  {
    if(this.requestIdParent!=null)
    {
      this.getRequestById(this.requestIdParent);
      this.dossierCredit.requestIdParent = this.requestIdParent;
      this.initFormFromParent(this.requestIdParent);
    }
  }

  getRequestById(requestIdParent) {
    this._requestService.getRequestById(requestIdParent).subscribe(
      (data) => {
        this.dossier = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  
  initFormFromParent(requestIdParent) {
    this._individualService.getIndividualByRequestId(requestIdParent).subscribe(
      (data) => {
        this.individual = data;
        this.dossierCredit.customerCode = this.individual.customerCode;
        this.dossierCredit.customerNumber = this.individual.customerNumber;
        this.dossierCredit.codeAgenceDomiciliation = this.individual.codeAgenceDomiciliation;
        this.dossierCredit.codeGestionnaireDomiciliation = this.individual.codeGestionnaireDomiciliation;
        this.dossierCredit.libelleAgenceDomiciliation = this.individual.libelleAgenceDomiciliation;
        this.dossierCredit.rib = this.individual.rib;
        this.dossierCredit.numeroCompte = this.individual.numeroCompte;
        this.dossierCredit.firstname = this.individual.firstname;
        this.dossierCredit.lastname = this.individual.lastname;
        this.dossierCredit.categorie = this.individual.categorie;
        this.dossierCredit.matricule = this.individual.matricule;
        this.dossierCredit.situationMatrimoniale = this.individual.situationMatrimoniale;
        this.dossierCredit.workPhone = this.individual.workPhone;
        this.dossierCredit.homePhone = this.individual.homePhone;
        this.dossierCredit.mobilePhone = this.individual.mobilePhone;
        this.dossierCredit.employeurName = this.individual.employerName;
        this.dossierCredit.email = this.individual.email;
        this.dossierCredit.adressePostale = this.individual.adressePostale;
        this.dossierCredit.adresseGeographique = this.individual.adresseGeographique;
        this.dossierCredit.typePiece = this.individual.typePiece;
        this.dossierCredit.dateExpPiece = this.individual.dateExpPiece;
        this.dossierCredit.dateNaissance = this.individual.dateNaissance;
        //this.dossierCredit.lieuNaissance = this.individual.lieuNaissance;
        this.dossierCredit.employeur = this.individual.employeur;
        this.filterTypeCreditsByEmployeur();
        this.dossierCredit.dateEmbauche = this.individual.dateEmbauche;
        this.dossierCredit.employeurAdresse = this.individual.employerAdresse;
        this.dossierCredit.ancienneteEmploi = this.individual.ancienneteEmploi;
        this.dossierCredit.profession = this.individual.profession;
        this.dossierCredit.fonctionDansEntreprise = this.individual.fonctionDansEntreprise;
        this.dossierCredit.salaireEmprunteur = this.individual.salaireEmprunteur;
        this.dossierCredit.salaireConjoint = this.individual.salaireConjoint;
        this.dossierCredit.domiciliationSalaire = this.individual.domiciliationSalaire;
        this.dossierCredit.montantLoyer = this.individual.montantLoyer;
        this.dossierCredit.montantAutreRevenu = this.individual.montantAutreRevenu;
        this.dossierCredit.totalEngagementActuel = this.individual.totalEngagementActuel;
        this.dossierCredit.chargeEmpruntSollicite = this.individual.chargeEmpruntSollicite;
        this.dossierCredit.montantBonusDat = this.individual.montantBonusDat;
        this.dossierCredit.primeTrimestrielle = this.individual.primeTrimestrielle;
        this.getListRetailItemByRequest(this.requestIdParent);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  
  getListRetailItemByRequest(requestIdParent) {
    this._retailItemService.getListRetailItemByRequest(requestIdParent).subscribe(
      (data) => {
        this.facilites = data;

        this.selectedTypeCredit = this.facilites[0].produit.typeCredit;
        this.selectedProduit = this.facilites[0].produit;

        this.form.controls['typeCredit'].setValue(this.facilites[0].produit.typeCredit.id);
        this.getListproduitByTypeCredit();
        this.form.controls['produit'].setValue(this.facilites[0].produit.id);
        this.form.controls['echeance'].setValue(this.facilites[0].echeance);
        this.form.controls['montant'].setValue(this.facilites[0].montant);
        this.form.controls['typeMontantVirementPermanent'].setValue(this.facilites[0].typeMontantVirementPermanent);
        this.getTauxFrais();
        this.getListAssuranceByAmount();
        this.form.controls['assurance'].setValue(this.facilites[0].assurance.id);
        this.form.controls['echeanceMensuelleEnCours'].setValue(this.facilites[0].echeanceMensuelleEnCours);
        this.form.controls['objetDemande'].setValue(this.facilites[0].objetDemande);
        this.form.controls['nombreEcheance'].setValue(this.facilites[0].nombreEcheance);
        this.form.controls['montantVirementPermanent'].setValue(this.facilites[0].montantVirementPermanent);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  

  
  searchAndRefresh():void
  {
    this.getBpParticulierBycodeclient(this.form.value.customerCode);
    this.getBpEngagementBycodeclient(this.form.value.customerCode);
  }

  

  getAllEmployeur() {
    this._employeurService.getAllEmployeurs()
      .pipe(
        timeout(5000),
        retry(3),
        catchError(error => {
          console.error('Erreur lors de la récupération:', error);
          return throwError(() => new Error('Erreur réseau. Veuillez réessayer plus tard.'));
        })
      )
      .subscribe(
        data => {
          this.employeurs = data.filter(x => x.active == true);
        },
        error => {
          console.log('Erreur après les réessais et le timeout:', error.message);
        }
      );
  }
  


  getListTypeCredit() 
  {
      this._typeCreditService.getListTypeCreditByWorkflow(this.workflowCode)
      .pipe(
        timeout(5000),
        retry(3),
        catchError(error => {
          console.error('Erreur lors de la récupération', error);
          return throwError(() => new Error('Erreur réseau. Veuillez réessayer plus tard.'));
        })
      )
      .subscribe(
        data => {
          this.allTypeCredits = data.sort((a, b) => (a.label > b.label) ? 1 : -1);
          this.filterTypeCreditsByEmployeur();
        },
        error => {
          console.log(error);
      });
  }

  filterTypeCreditsByEmployeur() {
    const employeur = (this.form && this.form.value && this.form.value.employeur)
      || (this.dossierCredit && this.dossierCredit.employeur);
    let credits = this.allTypeCredits ? this.allTypeCredits.slice() : [];

    if (employeur && employeur.label == 'PUBLIC') {
      credits = credits.filter(tc => tc.code !== 'RET_AVANCE_SUR_BOURSE');
    }

    this.typeCredits = credits;

    const currentTypeCreditId = this.form && this.form.value && this.form.value.typeCredit;
    if (currentTypeCreditId && !this.typeCredits.some(tc => tc.id === currentTypeCreditId)) {
      this.form.controls['typeCredit'].setValue(null);
      this.form.controls['produit'].setValue(null);
      this.selectedTypeCredit = null;
      this.produits = null;
    }
  }

  onEmployeurChange() {
    this.filterTypeCreditsByEmployeur();
  }


  getListproduitByTypeCredit(){

    this.selectedTypeCredit = this.typeCredits.find(typeCredit => typeCredit.id === this.form.value.typeCredit);
    this.produits = null;
    this._produitService.getListproduitByTypeCredit(this.selectedTypeCredit.id)
    .pipe(
      timeout(5000),
      retry(3),
      catchError(error => {
        console.error('Erreur lors de la récupération', error);
        return throwError(() => new Error('Erreur réseau. Veuillez réessayer plus tard.'));
      })
    )
    .subscribe(
      data => {
        
        this.produits = data;
        this.selectedProduit = this.produits.find(produit => produit.id === this.form.value.produit);
      },
      error => {
        console.log(error);
    });
  }

  
  getListAssuranceByAmount() {

    let amount = Number(this.form.value.montant);

    this.assurances = [];

    this._assuranceService.getAssurancesByAmount(this.selectedTypeCredit.code, amount)
    .pipe(
      timeout(5000),
      retry(3),
      catchError(error => {
        console.error('Erreur lors de la récupération', error);
        return throwError(() => new Error('Erreur réseau. Veuillez réessayer plus tard.'));
      })
    )
    .subscribe(
      data => {
        this.assurances = data;
      },
      error => {
        console.log(error);
    });
    
  }
  
  getTauxFrais()
  {
    debugger;
    this.isCalculated = false;

    this.selectedProduit = this.produits.find(produit => produit.id === this.form.value.produit);
    this.tauxFraisInput.codeProduit = this.selectedProduit.code;

    this.tauxFraisInput.codeTypeCredit = this.selectedTypeCredit.code;
    this.tauxFraisInput.employeur = this.form.value.employeur.label;
    this.tauxFraisInput.montantDemande = this.form.value.montant;
    this.tauxFraisInput.salaireEmprunteur = this.form.value.salaireEmprunteur;
    this.tauxFraisInput.montantLoyer = this.form.value.montantLoyer;
    this.tauxFraisInput.primeTrimestrielle = this.form.value.primeTrimestrielle;
    this.tauxFraisInput.echeanceMois = this.calculEcheanceAvecPeriodicite();
    this.tauxFraisInput.typeVirementPermant = this.form.value.typeMontantVirementPermanent;

    this._ruleParticulierService.ruleTauxFrais(this.tauxFraisInput)
    .pipe(
      timeout(5000),
      retry(3),
      catchError(error => {
        console.error('Erreur lors de la récupération', error);
        return throwError(() => new Error('Erreur réseau. Veuillez réessayer plus tard.'));
      })
    )
    .subscribe(
      data => {
        this.tauxFraisOutput = data;
        this.form.controls['echeanceMensuelleEnCours'].setValue(this.tauxFraisOutput.echeanceMensuelleEnCours);
        this.form.controls['taux'].setValue(this.tauxFraisOutput.taux);
        this.form.controls['frais'].setValue(this.tauxFraisOutput.frais);
        this.form.controls['montantVirementPermanent'].setValue(this.tauxFraisOutput.montantVirementPermanent);
        this.form.controls['montantVirementPonctuel'].setValue(this.tauxFraisOutput.montantVirementPonctuel);
        this.form.controls['assurance'].setValue(null);
      },
      error => {
        console.log(error);
    });
  }

  calculEcheanceAvecPeriodicite():number
  {
    let echeance = 0;

    if(this.form.value.periodicite == 'MENSUEL')
    {
      echeance = Number(this.form.value.echeance) * 1;
    }
    else if(this.form.value.periodicite == 'TRIMESTRIEL')
    {
      echeance = Number(this.form.value.echeance) * 3;
    }
    else if(this.form.value.periodicite == 'SEMESTRIEL')
    {
      echeance = Number(this.form.value.echeance) * 4;
    }
    else if(this.form.value.periodicite == 'ANNUEL')
    {
      echeance = Number(this.form.value.echeance) * 12;
    }

    return echeance
  }

  
  analyser()
  {
    this.analyseParticulierInput.codeTypeCredit = this.selectedTypeCredit.code;
    this.analyseParticulierInput.employeur = this.form.value.employeur.label;
    this.analyseParticulierInput.salaireEmprunteur = this.form.value.salaireEmprunteur;
    this.analyseParticulierInput.montantAutreRevenu = this.form.value.montantAutreRevenu;
    this.analyseParticulierInput.salaireConjoint = this.form.value.salaireConjoint;
    this.analyseParticulierInput.montantLoyer = this.form.value.montantLoyer;
    this.analyseParticulierInput.montantDemande = this.form.value.montant;
    this.analyseParticulierInput.echeanceMensuelleEnCours = this.form.value.echeanceMensuelleEnCours;
    this.analyseParticulierInput.echeanceMaxEmployeurMois = this.form.value.employeur.echeance;
    this.analyseParticulierInput.echeanceMois = this.calculEcheanceAvecPeriodicite();
    this.analyseParticulierInput.totalEngagementActuel = this.form.value.totalEngagementActuel;
    this.analyseParticulierInput.differe = this.form.value.differe;
    this.analyseParticulierInput.categorie = this.form.value.categorie;
    this.analyseParticulierInput.montantBonusDat = this.form.value.montantBonusDat;
    this.analyseParticulierInput.primeTrimestrielle = this.form.value.primeTrimestrielle;

    this._ruleParticulierService.ruleAnalyseCreditParticulier(this.analyseParticulierInput)
    .pipe(
      timeout(5000),
      retry(3),
      catchError(error => {
        console.error('Erreur lors de la récupération', error);
        return throwError(() => new Error('Erreur réseau. Veuillez réessayer plus tard.'));
      })
    )
    .subscribe(
      data => {
        this.isCalculated = true;
        this.analyseParticulierOutput = data;

        this.totalRevenuMensuel = this.analyseParticulierOutput.totalRevenuMensuel;
        this.totalEngagementMensuel = this.analyseParticulierOutput.totalEngagementMensuel;
        this.disponibleMensuel = this.analyseParticulierOutput.disponibleMensuel;
        this.quotite = this.analyseParticulierOutput.quotite;
        this.quotiteNormale = this.analyseParticulierOutput.quotiteNormale;
        this.avisAnalyseRisque = this.analyseParticulierOutput.avisAnalyseRisque;
        this.avisSurDemande = this.analyseParticulierOutput.avisSurDemande;
        this.decouvertMaximum = this.analyseParticulierOutput.decouvertMaximum;
        this.decouvertDepassement = this.analyseParticulierOutput.decouvertDepassement;
        this.quotiteApresEngagement = this.analyseParticulierOutput.quotiteApresEngagement;
        this.totalEgagementClient = this.analyseParticulierOutput.totalEgagementClient;
      },
      error => {
        console.log(error);
    });
  }

  
  getBpParticulierBycodeclient(codeclient) {

    this.spinner.show();

    this._bpParticulierService.getBpParticulierBycodeclient(codeclient)
    .pipe(
      timeout(5000),
      retry(3),
      catchError(error => {
        console.error('Erreur lors de la récupération', error);
        return throwError(() => new Error('Erreur réseau. Veuillez réessayer plus tard.'));
      })
    )
    .subscribe(
      data => {
        debugger
        this.bpParticulier = data;

        if(this.bpParticulier != null)
        {
          this.dossierCredit.firstname = this.bpParticulier.prenom;
          this.dossierCredit.lastname = this.bpParticulier.nom;

          if(this.bpParticulier.bpProfession != undefined && this.bpParticulier.bpProfession != null)
          {
            this.dossierCredit.profession = this.bpParticulier.bpProfession.libelle;
          }

          this.dossierCredit.email = this.bpParticulier.email;
          this.dossierCredit.mobilePhone = this.bpParticulier.telephone;
          this.dossierCredit.adressePostale = this.bpParticulier.adressepostal;
          this.dossierCredit.adresseGeographique = this.bpParticulier.adressegeo;
          
          this.dossierCredit.situationMatrimoniale = this.bpParticulier.matrimoniale;

          let date1 = this.bpParticulier.datembauche.split(" ")[0];
          let date2 = date1.split('-');
          let date3 = date2[0]+"/"+date2[1]+"/"+date2[2];
          let docDate = date3;
          this.dateControl = new FormControl(this.addMinutes(new Date(docDate),121));

        }
        else {
          this.dossierCredit.firstname = null;
          this.dossierCredit.lastname = null;
          this.dossierCredit.fonction = null;
          this.dossierCredit.email = null;
          this.dossierCredit.mobilePhone = null;
          this.dossierCredit.adressePostale = null;
          this.dossierCredit.adresseGeographique = null;
          this.dossierCredit.dateEmbauche = null;
        }

        this.spinner.hide();
        
      },
      error => {
        console.log(error);
        this.spinner.hide();
    });
    
  }

  getBpEngagementBycodeclient(codeclient) {

    this.spinner.show();
    this._bpEngagementService.getBpEngagementBycodeclient(codeclient)
    .pipe(
      timeout(5000),
      retry(3),
      catchError(error => {
        console.error('Erreur lors de la récupération', error);
        return throwError(() => new Error('Erreur réseau. Veuillez réessayer plus tard.'));
      })
    )
    .subscribe(
      data1 => {
        
        this.bpEngagement = data1;

        if(this.bpEngagement != null)
        {
          this.dossierCredit.totalEngagementActuel = this.bpEngagement.montant;
        }
        else
        {
          this.dossierCredit.totalEngagementActuel = 0;
        }

        this.spinner.hide();
        
      },
      error1 => {
        console.log(error1);
        this.spinner.hide();
    });
  }

  //
  validateDateExpPieceAndDateNaissance()
  {
    debugger
    if(this.form.value.dateExpPiece=='' || this.form.value.dateExpPiece==undefined)
    {
      this.form.controls['lieuNaissance'].setValue("");
      alert("La date d'exp de la pièce du client est obligatoire");
    }
    else
    {
      this.dateControlExpPiece = new FormControl(this.addMinutes(new Date(this.form.value.dateExpPiece),121));
    }
     
    if(this.form.value.dateNaissance=='' || this.form.value.dateNaissance==undefined)
    {
      this.form.controls['lieuNaissance'].setValue("");
      alert("La date de naissance du client est obligatoire");
    }
    else
    {
      this.dateControlNaissance = new FormControl(this.addMinutes(new Date(this.form.value.dateNaissance),121));
    }

  }

  synchChargeEmpruntSolliciteToEcheanceMensuelle()
  {
    this.isCalculated = false;
    let codeTypeCredit = this.selectedTypeCredit.code;

    if(codeTypeCredit != null)
    {

      if(codeTypeCredit == 'RET_DECOUVERT_PPO' || codeTypeCredit == 'RET_DECOUVERT_SANS_DETTE' || codeTypeCredit == 'RET_DECOUVERT' || codeTypeCredit == 'RET_DECOUVERT_BONUS' || codeTypeCredit == 'RET_DECOUVERT_PACKAGE')
      {
        this.form.controls['echeanceMensuelleEnCours'].setValue(0);
      }
      else
      {
        this.form.controls['echeanceMensuelleEnCours'].setValue(this.form.value.chargeEmpruntSollicite);
      }
  
    }
    else
    {
      this.form.controls['echeanceMensuelleEnCours'].setValue(0);
    }
  }

  
  synchronizationVpm()
  {
    this.isCalculated = false;
    if(
      this.selectedTypeCredit.code != 'RET_AGR' 
      && this.selectedTypeCredit.code != 'RET_MPE'
    )
    {
      this.form.controls['chargeEmpruntSollicite'].setValue(this.form.value.echeanceMensuelleEnCours);
    }
  }
  
  resetSalaireByTypeCredit()
  {
    this.isCalculated = false;
    if( this.selectedTypeCredit.code == 'RET_AVANCE_SUR_BOURSE' || this.selectedTypeCredit.code == 'RET_AVANCE_SUR_RAPPEL' )
    {
      this.form.controls['salaireEmprunteur'].setValue(0);
    }
  }

  changePeriodicite()
  {
    this.isCalculated = false;
    if(this.selectedTypeCredit.code == 'RET_PPO_PRIME_TRIMESTRIELLE' )
    {
      this.form.controls['periodicite'].setValue('TRIMESTRIEL');
    }
    else
    {
      if(this.form.value.categorie == 'PSPL' || this.form.value.categorie == 'PSPC' || this.form.value.categorie == 'PSIA')
      {
        this.form.controls['periodicite'].setValue('ANNUEL');
      }
    }
  }
verifyPackage() {
  this.isCalculated = false;

  const packageSouscrit = this.form.controls['packageSouscrit'].value;
  const salaire = Number(this.form.controls['salaireEmprunteur'].value);

  let isInvalid = false;

  switch (packageSouscrit) {
    case 'ESSENTIEL':
      if (salaire > 250000) isInvalid = true;
      break;

    case 'CLASSIC':
      if (salaire <= 250000 || salaire > 550000) isInvalid = true;
      break;

    case 'GOLD':
      if (salaire <= 550000 || salaire > 1250000) isInvalid = true;
      break;

    case 'PLATINUM':
      if (salaire <= 1250000 || salaire > 2500000) isInvalid = true;
      break;

    case 'INFINITE':
      if (salaire <= 2500000) isInvalid = true;
      break;

    case 'PREMIUM':
      if (salaire <= 2000000) isInvalid = true;
      break;
  }

  if (isInvalid) {
    this.form.controls['salaireEmprunteur'].setValue(0);
    alert("Le salaire ne correspond pas au package souscrit");
  }
}

  syncMontantBonusDatAndPrimeTrimestrielle()
  {
    this.isCalculated = false;
    if(this.selectedTypeCredit.code == 'RET_CREDIT_NOUVEL_AN')
    {
      this.form.controls['montantBonusDat'].setValue(0);
      this.form.controls['primeTrimestrielle'].setValue(0);
    }
    if(this.selectedTypeCredit.code == 'RET_CREDIT_03_ETOILES')
    {
      this.form.controls['montantBonusDat'].setValue(0);
      this.form.controls['primeTrimestrielle'].setValue(0);
    }

  }
  //



  create(): void 
  {
    debugger
    if(this.dateControl == undefined)
    {
      this.dossierCredit.dateEmbauche = null;
    }
    else
    {
      this.dossierCredit.dateEmbauche = this.dateControl.value;
    }
    if(this.dateControlExpPiece == undefined)
    {
      this.dossierCredit.dateExpPiece = null;
    }
    else
    {
      this.dossierCredit.dateExpPiece = this.dateControlExpPiece.value;
    }
    if(this.dateControlNaissance == undefined)
    {
      this.dossierCredit.dateNaissance = null;
    }
    else
    {
      this.dossierCredit.dateNaissance = this.dateControlNaissance.value;
    }

    const creditItem = new ParticulierFaciliteItem();
    creditItem.produit = this.form.value.produit;
    creditItem.periodicite = this.form.value.periodicite;
    creditItem.echeance = this.form.value.echeance;
    creditItem.montant = this.form.value.montant;
    creditItem.taux = this.form.value.taux;
    creditItem.echeanceMensuelleEnCours = this.form.value.echeanceMensuelleEnCours;
    creditItem.frais = this.form.value.frais;
    creditItem.assurance = this.form.value.assurance;
    creditItem.objetDemande = this.form.value.objetDemande;
    creditItem.typeMontantVirementPermanent = this.form.value.typeMontantVirementPermanent;
    creditItem.montantVirementPermanent = this.form.value.montantVirementPermanent;

    this.dossierCredit.particulierFaciliteItem = creditItem;
    const garanties = this.form.get("garantiesArrayForm").value;
    this.dossierCredit.garanties = garanties;
    this.dossierCredit.clientEngage = this.form.value.clientEngage;
    this.dossierCredit.typeCreditSouscrit = this.form.value.clientEngage
      ? this.form.value.typeCreditSouscrit
      : null;
    this.dossierCredit.montantCreditSolicite = this.form.value.montantCreditSolicite;
    this.dossierCredit.echeanceMensuelleCreditSolicite = this.form.value.echeanceMensuelleCreditSolicite;

    this.spinner.show();

    this.pressButton = true;
    this._particulierService.createDossier(this.dossierCredit)
    .pipe(
      first()
    )
    .subscribe(
        data => {
          this.spinner.hide();
          this._router.navigateByUrl('/mon-portefeuille/mes-dossiers');
        },
        error => {
          console.log(error);
          this.errorMessage = error.error.message;
          this.pressButton = false;
          this.spinner.hide();
    });
  }

  
  addMinutes(date, minutes):Date
  {
    return new Date(date.getTime() + minutes*60000);
  }


}
